import React from 'react'
import { Admin } from '../components/Admin/Admin'
import { AddDoct } from '../components/Admin/AddDoct'
import { Button } from '@chakra-ui/react'

export const AdminPage = () => {
  
  return (
    <div>
        <Admin/>
    </div>
  )
}
